class MainNav {
  constructor() {
    this.triggers = document.querySelectorAll('[data-megamenu-trigger]');
    this.triggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => this.showMegamenu(trigger.dataset.megamenuTrigger));
      trigger.addEventListener('mouseleave', () => this.hideMegamenu(trigger.dataset.megamenuTrigger));
    });
  }

  showMegamenu(type) {
    document.dispatchEvent(new CustomEvent('showMegamenu', { detail: { type } }));
  }

  hideMegamenu(type) {
    document.dispatchEvent(new CustomEvent('hideMegamenu', { detail: { type } }));
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new MainNav();
}); 